<template>
  <div class="user-center">
    <div class="content-box">
      <!-- <div
        class="info-box"
        style="padding: 10px 0px">
        <div class="avatar-box avatar-bg">
          <div>
            <img
              v-if="userInfo.photo"
              :src="`${imageBaseUrl}/${userInfo.photo}?token=${getTokenId()}`"
              class="avatar" />
            <div
              v-else
              class="avatar">
              {{ userInfo.surname && userInfo.surname[0].toUpperCase() }}
            </div>
          </div>
          <div class="name">{{ userInfo.surname }}</div>
          <el-upload
            ref="uploadImg"
            :action="action"
            :headers="pictureHeaders"
            :data="uploadParams"
            :limit="1"
            name="FileInfo"
            accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
            :show-file-list="false"
            :before-upload="onBeforeUpload"
            :on-success="handleAvatarSuccess"
            :on-error="onAvatarError">
            <div class="common-button-box">
              <el-button
                class="normal-btn"
                size="small"
                type="primary"
                >更改照片</el-button
              >
            </div>
          </el-upload>
        </div>
      </div> -->
      <div class="info-box">
        <div class="info-box-title">账号信息</div>
        <ul class="info-box-content">
          <div class="left userName">
            <div class="userCount">
              <div class="name">{{ isStarRiver ? '账号ID' : '用户名' }}:</div>
              <div
                class="value"
                v-if="!editUserName">
                {{ userInfo.surname }}
              </div>
              <el-input
                v-else
                class="input-primary"
                size="small"
                v-model="userNameInfo"
                placeholder="请输入用户账号"></el-input>
            </div>
            <div class="userChange">
              <el-button
                class="normal-btn"
                size="mini"
                v-if="editUserName"
                @click="cancelEditUserName"
                >取消</el-button
              >
              <el-button
                class="normal-btn"
                size="mini"
                @click="copyAccount"
                >复制</el-button
              >
              <!-- <el-button
                class="normal-btn"
                size="mini"
                @click="updateUserName"
                >{{ editUserName ? '保存' : '修改' }}</el-button
              > -->
            </div>
          </div>
          <div class="info-box-content-hor avatar-header">
            <div class="left">
              <div class="name">头像:</div>
              <div class="value avatar-value">
                <img
                  v-if="userInfo.photo"
                  :src="`${imageBaseUrl}/${
                    userInfo.photo
                  }?token=${getTokenId()}`"
                  class="avatar" />
                <div
                  v-else
                  class="avatar">
                  <!-- {{ userInfo.surname && userInfo.surname[0].toUpperCase() }} -->
                  <i class="el-icon-user-solid"></i>
                </div>
              </div>
            </div>
            <div class="right">
              <el-upload
                ref="uploadImg"
                :action="action"
                :headers="pictureHeaders"
                :data="uploadParams"
                :limit="1"
                name="FileInfo"
                accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
                :show-file-list="false"
                :before-upload="onBeforeUpload"
                :on-success="handleAvatarSuccess"
                :on-error="onAvatarError">
                <div class="common-button-box">
                  <el-button
                    class="normal-btn"
                    size="small"
                    type="primary"
                    >更换</el-button
                  >
                </div>
              </el-upload>
            </div>
          </div>
          <div class="info-box-content-hor avatar-header">
            <div class="left avatar-header-password">
              <div class="name">密码:</div>
              <div class="value">
                <span class="special-character">***********</span>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                size="mini"
                @click="update('password')"
                >修改</el-button
              >
            </div>
          </div>
          <div class="left">
            <div class="name">最近登录:</div>
            <div class="value">{{ recentLogin }}</div>
          </div>
          <div class="left">
            <div class="name">注册时间:</div>
            <div class="value">{{ formatTime(userInfo.creationTime) }}</div>
          </div>
        </ul>
      </div>
      <div class="info-box">
        <div class="info-box-title">组织信息</div>
        <ul class="info-box-content">
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">公司:</div>
              <div
                v-if="editField !== 'company'"
                class="value">
                {{ userInfo?.company || '--' }}
              </div>
              <div
                class="value"
                v-if="editField === 'company'">
                <el-input
                  class="input-primary"
                  size="small"
                  v-model="userInfo.company"
                  placeholder="请输入公司名称"></el-input>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                v-if="editField !== 'company'"
                size="mini"
                @click="edit('company')"
                >修改</el-button
              >
              <el-button
                class="normal-btn"
                v-if="editField === 'company'"
                size="mini"
                @click="cancelEdit()"
                >取消</el-button
              >
              <el-button
                class="primary-btn"
                v-if="editField === 'company'"
                size="mini"
                @click="save()"
                >保存</el-button
              >
            </div>
          </div>
          <div class="info-box-content-hor comparType">
            <div class="left">
              <div class="name">企业类型:</div>
              <div
                v-if="editField !== 'enterpriseType'"
                class="value">
                {{
                  userInfo.enterpriseType === '其他'
                    ? userInfo.enterpriseTypeInput
                    : userInfo.enterpriseType
                }}
              </div>
              <div v-if="editField === 'enterpriseType'">
                <div class="flex-item-box">
                  <div class="common-select-box">
                    <el-select
                      class="primary-select"
                      size="small"
                      v-model="userInfo.enterpriseType"
                      placeholder="请选择您的企业类型"
                      :popper-append-to-body="false">
                      <el-option value="施工单位">施工单位</el-option>
                      <el-option value="设计单位">设计单位</el-option>
                      <el-option value="建设方">建设方</el-option>
                      <el-option value="科技公司">科技公司</el-option>
                      <el-option value="高校">高校</el-option>
                      <el-option value="其他">其他</el-option>
                    </el-select>
                  </div>
                  <div
                    class="common-input-box"
                    v-if="userInfo.enterpriseType === '其他'">
                    <el-input
                      class="input-primary"
                      size="small"
                      v-model="userInfo.enterpriseTypeInput"
                      placeholder="请输入企业类型"></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                v-if="editField !== 'enterpriseType'"
                size="mini"
                @click="edit('enterpriseType')"
                >修改</el-button
              >
              <el-button
                class="normal-btn"
                v-if="editField === 'enterpriseType'"
                size="mini"
                @click="cancelEdit()"
                >取消</el-button
              >
              <el-button
                class="primary-btn"
                v-if="editField === 'enterpriseType'"
                size="mini"
                @click="save()"
                >保存</el-button
              >
            </div>
          </div>
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">所在省份:</div>
              <div
                v-if="editField !== 'province'"
                class="value">
                {{ userInfo.province }}
              </div>
              <div v-if="editField === 'province'">
                <div class="common-select-box">
                  <el-select
                    class="primary-select"
                    size="small"
                    v-model="userInfo.province"
                    filterable
                    placeholder="请选择您的所在省份"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                v-if="editField !== 'province'"
                size="mini"
                @click="edit('province')"
                >修改</el-button
              >
              <el-button
                class="normal-btn"
                v-if="editField === 'province'"
                size="mini"
                @click="cancelEdit()"
                >取消</el-button
              >
              <el-button
                class="primary-btn"
                v-if="editField === 'province'"
                size="mini"
                @click="save()"
                >保存</el-button
              >
            </div>
          </div>
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">姓名:</div>
              <div
                v-if="editField !== 'name'"
                class="value">
                {{ userInfo.name }}
              </div>
              <div v-if="editField === 'name'">
                <el-input
                  class="input-primary"
                  size="small"
                  v-model="userInfo.name"
                  placeholder="请输入姓名"></el-input>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                v-if="editField !== 'name'"
                size="mini"
                @click="edit('name')"
                >修改</el-button
              >
              <el-button
                class="normal-btn"
                v-if="editField === 'name'"
                size="mini"
                @click="cancelEdit()"
                >取消</el-button
              >
              <el-button
                class="primary-btn"
                v-if="editField === 'name'"
                size="mini"
                @click="save()"
                >保存</el-button
              >
            </div>
          </div>
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">职位:</div>
              <div
                v-if="editField !== 'position'"
                class="value">
                {{
                  userInfo.position === '其他'
                    ? userInfo?.positionInput || '--'
                    : userInfo?.position || '--'
                }}
              </div>
              <div v-if="editField === 'position'">
                <div class="flex-item-box">
                  <div class="common-select-box">
                    <el-select
                      class="primary-select"
                      size="small"
                      v-model="userInfo.position"
                      placeholder="请选择您的岗位"
                      :popper-append-to-body="false">
                      <el-option value="软件开发">软件开发</el-option>
                      <el-option value="建模设计">建模设计</el-option>
                      <el-option value="工程管理">工程管理</el-option>
                      <el-option value="其他">其他</el-option>
                    </el-select>
                  </div>
                  <div
                    class="common-input-box"
                    v-if="userInfo.position === '其他'">
                    <el-input
                      class="input-primary"
                      size="small"
                      v-model="userInfo.positionInput"
                      placeholder="请输入岗位" />
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                v-if="editField !== 'position'"
                size="mini"
                @click="edit('position')"
                >修改</el-button
              >
              <el-button
                class="normal-btn"
                v-if="editField === 'position'"
                size="mini"
                @click="cancelEdit()"
                >取消</el-button
              >
              <el-button
                class="primary-btn"
                v-if="editField === 'position'"
                size="mini"
                @click="save()"
                >保存</el-button
              >
            </div>
          </div>
        </ul>
      </div>
      <div class="info-box company-info">
        <div class="info-box-title">联系信息</div>
        <ul class="info-box-content">
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">手机:</div>
              <div class="value">
                {{ userInfo.phoneNumber && userInfo.phoneNumber.substr(0, 3) }}
                <span class="special-character">****</span>
                {{ userInfo.phoneNumber && userInfo.phoneNumber.substr(7) }}
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                size="mini"
                @click="update('phoneNumber')"
                >修改</el-button
              >
            </div>
          </div>
          <div class="info-box-content-hor">
            <div class="left">
              <div class="name">邮箱:</div>
              <div class="value">
                {{ userInfo.email ? userInfo.email : '暂未绑定' }}
              </div>
            </div>
            <div class="right">
              <el-button
                class="normal-btn"
                size="mini"
                @click="update('email')"
                >{{ userInfo.email ? '修改' : '绑定' }}</el-button
              >
            </div>
          </div>
        </ul>
      </div>
    </div>
    <drag-dialog
      :title="dialogTitle"
      :visible.sync="visible"
      :footerBtn="footerBtn"
      :defaultTop="350"
      :defaultLeft="700"
      :submit="submit"
      :cancel="closeDialog">
      <div
        class="steps"
        v-if="steps">
        <div :class="`steps-item ${steps <= 2 ? 'active' : ''}`">
          <span>① 验证</span>
          <span class="step-line"></span>
        </div>
        <div :class="`steps-item ${steps === 2 ? 'active' : ''}`">
          <span>② 绑定成功</span>
        </div>
      </div>
      <el-form
        class="form public-form-primary"
        v-if="updateType === 'phoneNumber'"
        :model="mobileForm"
        :rules="rules"
        label-width="100px"
        ref="mobileForm">
        <div v-if="steps === 1">
          <el-form-item
            label="新手机号:"
            prop="phone">
            <el-input
              class="input-primary"
              size="small"
              maxlength="11"
              placeholder="请输入新的手机号码"
              v-model="mobileForm.phone">
            </el-input>
          </el-form-item>
          <div class="validate">
            <el-form-item
              label="验证码:"
              prop="validateNo"
              style="width: 100%; margin-bottom: 0px; margin-right: 16px">
              <el-input
                class="input-primary"
                size="small"
                maxlength="6"
                placeholder="请输入手机验证码"
                v-model="mobileForm.validateNo"></el-input>
            </el-form-item>
            <div>
              <el-button
                class="normal-btn normal-ang-btn"
                :class="`action-btn ${
                  mobileForm.btnDisable ? 'action-btn-active' : ''
                }`"
                :disabled="mobileForm.btnDisable"
                @click="sendValidateNo('BindPhone')"
                >{{ mobileForm.btnName }}</el-button
              >
            </div>
          </div>
        </div>
        <div v-if="steps === 2">
          <div class="success-img">
            <icon-svg
              icon-class="icon-succeed"
              size="40"
              class="icon" />
          </div>
          <el-button
            class="primary-btn success-btn"
            @click="onSuccess"
            >绑定成功</el-button
          >
        </div>
      </el-form>
      <el-form
        class="form public-form-primary change-password-form"
        v-if="updateType === 'password'"
        :model="passwordForm"
        :rules="rules"
        label-width="92px"
        ref="passwordForm">
        <el-form-item
          label="原密码:"
          prop="currentPassword">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入原密码"
            show-password
            prefix-icon="el-icon-lock"
            v-model="passwordForm.currentPassword">
          </el-input>
        </el-form-item>
        <el-form-item
          label="设置密码:"
          prop="newPassword">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入新密码"
            show-password
            prefix-icon="el-icon-lock"
            v-model="passwordForm.newPassword">
          </el-input>
        </el-form-item>
        <el-form-item
          label="重复密码:"
          prop="confirmPassword">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请再次输入新密码"
            show-password
            prefix-icon="el-icon-lock"
            v-model="passwordForm.confirmPassword">
          </el-input>
        </el-form-item>
      </el-form>
      <el-form
        class="form public-form-primary"
        v-if="updateType === 'email'"
        :model="emailForm"
        :rules="rules"
        label-width="60px"
        ref="emailForm">
        <div v-if="steps === 1">
          <el-form-item
            label="邮箱:"
            prop="email">
            <el-input
              class="input-primary"
              size="small"
              placeholder="请输入邮箱地址"
              v-model="emailForm.email">
            </el-input>
          </el-form-item>
          <div class="validate">
            <el-form-item
              label="验证码:"
              prop="validateNo"
              style="margin-bottom: 0px; margin-right: 16px">
              <el-input
                class="input-primary"
                size="small"
                maxlength="6"
                placeholder="请输入邮箱验证码"
                v-model="emailForm.validateNo"></el-input>
            </el-form-item>
            <div>
              <el-button
                class="normal-btn normal-ang-btn"
                :class="`action-btn ${
                  emailForm.btnDisable ? 'action-btn-active' : ''
                }`"
                :disabled="emailForm.btnDisable"
                @click="sendMailValidateNo('BindMail')"
                >{{ emailForm.btnName }}</el-button
              >
            </div>
          </div>
        </div>
        <div v-if="steps === 2">
          <div class="success-img">
            <icon-svg
              icon-class="icon-succeed"
              size="40"
              class="icon" />
          </div>
          <el-button
            class="success-btn primary-btn"
            @click="onSuccess"
            >绑定成功</el-button
          >
        </div>
      </el-form>
    </drag-dialog>
  </div>
</template>
<script>
import dragDialog from '@/components/DragDialog.vue'
import eventBus from '@/utils/eventBus'
import {
  formatTime,
  getToken,
  encryptPassword,
  getTokenId,
  copyText
} from '@/utils/generalMethods'

import {
  enterpriseTypeInputRules,
  positionInputRules
} from '@/utils/formValidateRules'

import {
  getUserInfoByCenter,
  userChangePasswword,
  sendValidateNoService,
  sendMailValidateNoService,
  userChangePhone,
  userChangeEmail,
  userChangeCompany,
  userChangeEnterpriseType,
  userChangeProvince,
  userChangeName,
  userChangeUserName,
  userChangePosition,
  userSavePhoto
} from '@/service/interface'

const provinceList = [
  '北京市',
  '上海市',
  '天津市',
  '重庆市',
  '湖北省',
  '湖南省',
  '广东省',
  '河南省',
  '河北省',
  '山东省',
  '山西省',
  '江苏省',
  '江西省',
  '浙江省',
  '黑龙江省',
  '辽宁省',
  '吉林省',
  '甘肃省',
  '青海省',
  '陕西省',
  '海南省',
  '福建省',
  '安徽省',
  '云南省',
  '贵州省',
  '四川省',
  '广西壮族自治区',
  '宁夏回族自治区',
  '内蒙古自治区',
  '西藏自治区',
  '新疆维吾尔自治区',
  '台湾省',
  '香港特别行政区',
  '澳门特别行政区'
]
const enterpriseTypeList = [
  '施工单位',
  '设计单位',
  '建设方',
  '科技公司',
  '高校'
]
const positionList = ['软件开发', '建模设计', '工程管理']
export default {
  data() {
    const validPasswordAgain = (rule, value, callback) => {
      if (value === this.passwordForm.newPassword) {
        callback()
      } else {
        return callback(new Error('两次输入密码不一致'))
      }
    }
    return {
      isStarRiver: window.isStarRiver,

      imageBaseUrl: window.imageBaseUrl,
      headers: {},
      pictureHeaders: {
        Authorization: this.getToken()
      },
      uploadParams: {
        FileSize: '',
        FileName: ''
      },
      userInfo: {},
      userNameInfo: '',
      footerBtn: ['cancel', 'submit'],
      recentLogin: '',
      editField: '',
      updateType: '',
      steps: '',
      visible: false,
      dialogTitle: '',
      mobileForm: {
        phone: '',
        validateNo: '',
        btnName: '发送验证码',
        btnDisable: false
      },
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      emailForm: {
        email: '',
        validateNo: '',
        btnName: '发送验证码',
        btnDisable: false
      },
      enterpriseTypeInput: '',
      positionInput: '',
      provinceList: provinceList,
      rules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$.@$!%*?&#])[A-Za-z\d$.@$!%*?&#]{8,24}/,
            message:
              '8-24位字符, 至少包含大小写字母、数字、特殊字符(.@$!%*?&#)各一位',
            trigger: 'blur'
          }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$.@$!%*?&#])[A-Za-z\d$.@$!%*?&#]{8,24}/,
            message:
              '8-24位字符, 至少包含大小写字母、数字、特殊字符(.@$!%*?&#)各一位',
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$.@$!%*?&#])[A-Za-z\d$.@$!%*?&#]{8,24}/,
            message:
              '8-24位字符, 至少包含大小写字母、数字、特殊字符(.@$!%*?&#)各一位',
            trigger: 'blur'
          },
          { validator: validPasswordAgain, trigger: 'blur' }
        ]
      },
      editUserName: false
    }
  },
  components: {
    dragDialog
  },
  created() {
    this.action = `${
      window.serverUrl
    }/${this.$logServeCof()}/project/fileManage/v3/userPhoto/upload`
    this.headers = {
      Authorization: this.getToken()
    }
    this.initUserInfo()
  },
  methods: {
    copyAccount() {
      copyText(this.userInfo.surname)
    },
    cancelEditUserName() {
      this.editUserName = false
      this.userNameInfo = this.userInfo.surname
    },
    updateUserName() {
      if (this.editUserName) {
        let param = {
          userName: this.userNameInfo
        }
        userChangeUserName(param, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              this.$message.success('修改成功!')
              this.editField = ''
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                  } else {
                    this.$message.error(result.errMsg)
                  }
                }
              })
              this.editUserName = false
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
        return
      }
      this.editUserName = !this.editUserName
    },
    initUserInfo() {
      getUserInfoByCenter().then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            let userInfo = data.data
            if (!enterpriseTypeList.includes(userInfo.enterpriseType)) {
              userInfo.enterpriseTypeInput = userInfo.enterpriseType
              userInfo.enterpriseType = '其他'
            }
            if (!positionList.includes(userInfo.position)) {
              userInfo.positionInput = userInfo.position
              userInfo.position = '其他'
            }
            this.userInfo = userInfo
            this.userNameInfo = userInfo.surname
            let recentLogin = JSON.parse(sessionStorage.getItem('recentLogin'))
            recentLogin = new Date(recentLogin).toUTCString()
            this.recentLogin = this.formatTime(recentLogin)
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    sendValidateNo(validateType) {
      this.$refs.mobileForm.validate((bool, object) => {
        if (bool) {
          let params = {
            phone: this.mobileForm.phone,
            validateType
          }
          let startTime = new Date().getTime()
          this.mobileForm.btnDisable = true
          this.mobileForm.btnName = `60s后重试`
          this.timer = setInterval(() => {
            let currentTime = new Date().getTime()
            let deltaTime = parseInt((currentTime - startTime) / 1000)
            if (deltaTime >= 60) {
              clearInterval(this.timer)
              this.timer = null
              this.mobileForm.btnDisable = false
              this.mobileForm.btnName = '发送验证码'
            } else {
              this.mobileForm.btnDisable = true
              this.mobileForm.btnName = `${60 - deltaTime}s后重试`
            }
          }, 1000)
          sendValidateNoService(params, { headers: this.headers }).then(res => {
            if (res.status === 200) {
              let data = res.data
              if (data.isSuccess) {
                this.$message.success('验证码发送成功')
              } else {
                this.$message.error(data.errMsg)

                this.mobileForm.validateNo = ''
                this.$refs.mobileForm.resetFields()

                this.timer && clearInterval(this.timer)
                this.timer = null
                this.mobileForm.btnDisable = false
                this.mobileForm.btnName = '发送验证码'
              }
            }
          })
        }
      })
    },
    sendMailValidateNo(validateType) {
      this.$refs.emailForm.validate((bool, object) => {
        if (bool) {
          let params = {
            email: this.emailForm.email,
            validateType
          }
          let startTime = new Date().getTime()
          this.emailForm.btnDisable = true
          this.emailForm.btnName = `60s后重试`
          this.timer = setInterval(() => {
            let currentTime = new Date().getTime()
            let deltaTime = parseInt((currentTime - startTime) / 1000)
            if (deltaTime >= 60) {
              clearInterval(this.timer)
              this.timer = null
              this.emailForm.btnDisable = false
              this.emailForm.btnName = '发送验证码'
            } else {
              this.emailForm.btnDisable = true
              this.emailForm.btnName = `${60 - deltaTime}s后重试`
            }
          }, 1000)
          sendMailValidateNoService(params, { headers: this.headers }).then(
            res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.$message.success('验证码发送成功')
                } else {
                  this.$message.error(data.errMsg)

                  this.emailForm.validateNo = ''
                  this.$refs.mobileForm.resetFields()

                  this.timer && clearInterval(this.timer)
                  this.timer = null
                  this.emailForm.btnDisable = false
                  this.emailForm.btnName = '发送验证码'
                }
              }
            }
          )
        }
      })
    },
    edit(fieldName) {
      getUserInfoByCenter().then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            let userInfo = data.data
            if (!enterpriseTypeList.includes(userInfo.enterpriseType)) {
              userInfo.enterpriseTypeInput = userInfo.enterpriseType
              userInfo.enterpriseType = '其他'
            }
            if (!positionList.includes(userInfo.position)) {
              userInfo.positionInput = userInfo.position
              userInfo.position = '其他'
            }
            this.userInfo = userInfo

            this.editField = fieldName
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    save() {
      if (this.editField === 'company') {
        let param = {
          company: this.userInfo.company
        }
        userChangeCompany(param, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              this.$message.success('修改成功！！！')
              this.editField = ''
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                  } else {
                    this.$message.error(result.errMsg)
                  }
                }
              })
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
      }
      if (this.editField === 'enterpriseType') {
        if (this.userInfo.enterpriseType === '其他') {
          if (!this.userInfo.enterpriseTypeInput) {
            this.$message.warning('请输入企业类型')
            return
          }

          if (
            !enterpriseTypeInputRules.pattern.test(
              this.userInfo.enterpriseTypeInput
            )
          ) {
            let msg =
              '企业类型需要中英文开头, 只支持汉字、字母、数字和-_()[], 且不少于两个字符'
            this.$message.warning(msg)
            return
          }
        }

        let param = {
          enterpriseType: this.userInfo.enterpriseType
        }
        if (param.enterpriseType === '其他') {
          param.enterpriseType = this.userInfo.enterpriseTypeInput
        }
        userChangeEnterpriseType(param, { headers: this.headers }).then(
          response => {
            if (response.status === 200) {
              let data = response.data
              if (data.isSuccess) {
                this.$message.success('修改成功！！！')
                this.editField = ''
                getUserInfoByCenter().then(res => {
                  if (res.status === 200) {
                    let result = res.data
                    if (result.isSuccess) {
                      this.userInfo = result.data
                    } else {
                      this.$message.error(result.errMsg)
                    }
                  }
                })
              } else {
                this.$message.error(data.errMsg)
              }
            }
          }
        )
      }
      if (this.editField === 'name') {
        let param = {
          name: this.userInfo.name
        }
        userChangeName(param, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              this.$message.success('修改成功！！！')
              this.editField = ''
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                  } else {
                    this.$message.error(result.errMsg)
                  }
                }
              })
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
      }
      if (this.editField === 'position') {
        if (this.userInfo.position === '其他') {
          if (!this.userInfo.positionInput) {
            this.$message.warning('请输入企业类型')
            return
          }

          if (!positionInputRules.pattern.test(this.userInfo.positionInput)) {
            let msg =
              '职位名称需要中英文开头, 支持汉字、字母、数字, 且不少于两个字符'
            this.$message.warning(msg)
            return
          }
        }

        let param = {
          position: this.userInfo.position
        }
        if (param.position === '其他') {
          param.position = this.userInfo.positionInput
        }
        userChangePosition(param, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              this.$message.success('修改成功！！！')
              this.editField = ''
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                  } else {
                    this.$message.error(result.errMsg)
                  }
                }
              })
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
      }
      if (this.editField === 'province') {
        let param = {
          province: this.userInfo.province
        }
        userChangeProvince(param, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              this.$message.success('修改成功！！！')
              this.editField = ''
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                  } else {
                    this.$message.error(result.errMsg)
                  }
                }
              })
            } else {
              this.$message.error(data.errMsg)
            }
          }
        })
      }
    },
    cancelEdit() {
      getUserInfoByCenter().then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            let userInfo = data.data
            if (!enterpriseTypeList.includes(userInfo.enterpriseType)) {
              userInfo.enterpriseTypeInput = userInfo.enterpriseType
              userInfo.enterpriseType = '其他'
            }
            if (!positionList.includes(userInfo.position)) {
              userInfo.positionInput = userInfo.position
              userInfo.position = '其他'
            }
            this.userInfo = userInfo
            this.editField = ''
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    update(updateType) {
      this.visible = true
      this.updateType = updateType

      if (updateType === 'phoneNumber') {
        this.steps = 1
        this.dialogTitle = '修改手机号'
      }
      if (updateType === 'password') {
        this.steps = ''
        this.dialogTitle = '修改密码'
      }
      if (updateType === 'email') {
        this.steps = 1
        this.dialogTitle = this.userInfo.email ? '修改邮箱' : '绑定邮箱'
      }
    },
    submit() {
      if (this.updateType === 'password') {
        this.$refs.passwordForm.validate((bool, object) => {
          if (bool) {
            let params = {
              currentPassword: encryptPassword(
                this.passwordForm.currentPassword
              ),
              newPassword: encryptPassword(this.passwordForm.newPassword),
              confirmPassword: encryptPassword(
                this.passwordForm.confirmPassword
              )
            }
            userChangePasswword(params, { headers: this.headers }).then(res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.$message.success('密码修改成功！！！')
                  if (window.isPrivate) {
                    this.$router.push(`../privateLogin`)
                  } else {
                    this.$router.push(`../login`)
                  }
                } else {
                  this.$message.error(`${data.errMsg}, 请重试`)
                }
                this.passwordForm = {
                  currentPassword: '',
                  newPassword: '',
                  confirmPassword: ''
                }
                this.closeDialog()
              }
            })
          }
        })
      }
      if (this.updateType === 'phoneNumber') {
        this.$refs.mobileForm.validate((bool, object) => {
          if (bool) {
            let params = {
              phone: this.mobileForm.phone,
              validateNo: this.mobileForm.validateNo
            }
            userChangePhone(params, { headers: this.headers }).then(res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.steps = 2
                  this.footerBtn = []
                } else {
                  this.$message.error(`${data.errMsg}, 请重试`)
                }
                this.mobileForm = {
                  phone: '',
                  validateNo: '',
                  btnName: '发送验证码',
                  btnDisable: false
                }
              }
            })
          }
        })
      }
      if (this.updateType === 'email') {
        this.$refs.emailForm.validate((bool, object) => {
          if (bool) {
            let params = {
              email: this.emailForm.email,
              validateNo: this.emailForm.validateNo
            }
            userChangeEmail(params, { headers: this.headers }).then(res => {
              if (res.status === 200) {
                let data = res.data
                if (data.isSuccess) {
                  this.steps = 2
                  this.footerBtn = []
                } else {
                  this.$message.error(`${data.errMsg}, 请重试`)
                }
                this.emailForm = {
                  email: '',
                  validateNo: '',
                  btnName: '发送验证码',
                  btnDisable: false
                }
              }
            })
          }
        })
      }
    },
    closeDialog() {
      this.updateType = ''
      this.visible = false
      this.footerBtn = ['cancel', 'submit']
    },
    onSuccess() {
      getUserInfoByCenter().then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.userInfo = data.data
            this.closeDialog()
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    onBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('文件大小不能超过2M')
        return false
      }
      this.$set(this.uploadParams, 'FileSize', file.size)
      this.$set(this.uploadParams, 'FileName', file.name)
    },
    handleAvatarSuccess(response) {
      if (response.isSuccess) {
        let pictureInfo = response.data
        let params = {
          photoUrl: pictureInfo.savePath
        }
        userSavePhoto(params, { headers: this.headers }).then(response => {
          if (response.status === 200) {
            let data = response.data
            if (data.isSuccess) {
              getUserInfoByCenter().then(res => {
                if (res.status === 200) {
                  let result = res.data
                  if (result.isSuccess) {
                    this.userInfo = result.data
                    eventBus.$emit('updateUserPhone')
                  } else {
                    this.$message.error(result.errMsg)
                  }
                  this.$refs.uploadImg.clearFiles()
                }
              })
            }
          }
        })
      } else {
        this.$message.error(response.errMsg)
        this.$refs.uploadImg.clearFiles()
      }
    },
    onAvatarError() {
      this.$message.error('图片上传失败')
      this.$refs.uploadImg.clearFiles()
    },
    getToken,
    formatTime,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
.user-center {
  min-height: 100%;
  background-color: var(--page-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  border-radius: 16px;
  height: 100%;
  overflow-y: auto;
  padding-top: 16px;
  &::-webkit-scrollbar {
    display: none;
  }

  .el-button--default {
    height: unset;
  }

  .content-box {
    width: 60%;
    min-width: 800px;
    margin: 0px auto;
    text-align: left;

    .title {
      padding: 10px 20px;
      line-height: 25px;
      color: var(--default-color);
      font-size: 16px;
      border-bottom: 1px solid var(--base-bg-dark-color29);
    }

    // .avatar-bg {
    //   padding: 10px 0px;
    //   background: url("../assets/img/usercenter_bg.png") no-repeat center/cover;
    // }

    .info-box {
      border: 1px solid var(--usercenter-item-border-color);
      border-radius: 8px;
      margin-bottom: 24px;

      &.company-info {
        margin-bottom: 0;
      }

      &-title {
        height: 32px;
        line-height: 32px;
        padding-left: 32px;
        background-color: var(--usercenter-item-header-bgColor);
        font-size: 14px;
        font-weight: 400;
        color: var(--usercenter-item-header-text-color);
      }

      &-content {
        padding: 24px 64px;

        .comparType {
          .flex-item-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .common-select-box {
              margin-right: 16px;
            }
          }
        }

        .left {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          &:not(:last-child) {
            margin-bottom: 18px;
          }

          .value,
          .name {
            font-size: 14px;
            font-weight: 400;
            color: var(--usercenter-item-content-text-color);
            margin-left: 8px;

            .input-primary {
              margin-left: -8px;
            }
          }

          .name {
            margin-right: 8px;
            min-width: 60px;
            text-align: right;
          }

          .flex-item-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .common-select-box {
              margin-right: 16px;
            }
          }

          .avatar-value {
            width: 32px;
            height: 32px;
            margin: 0px auto;
            border-radius: 8px;
            line-height: 32px;
            font-size: 30px;
            text-align: center;
            background: var(--header-avatar-bgColor);
            overflow: hidden;
            margin-left: 8px;

            .avatar {
              width: 100%;
              height: 100%;
              font-size: 18px;
              color: var(--header-icon-color);
              font-size: 21px;
            }
          }
        }

        .userName {
          justify-content: space-between;
          height: 32px;

          .userCount {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .value {
              height: 32px;
              line-height: 32px;
              margin-bottom: 2px;
            }
          }
        }

        &-hor {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left {
            height: 32px;
          }
        }

        .avatar-header {
          margin-bottom: 18px;
          .left {
            margin-bottom: 0;
          }

          &-password {
            .special-character {
              margin-top: 6px;
              display: flex;
            }
          }
        }
      }
      .avatar-box {
        text-align: center;
        color: var(--default-color);

        .avatar {
          width: 50px;
          height: 50px;
          margin: 0px auto;
          border-radius: 50%;
          line-height: 50px;
          font-size: 30px;
          text-align: center;
          background: var(--base-primary-color);
        }

        .name {
          margin: 10px 0px;
        }
      }

      .info {
        color: var(--default-color);
        font-size: 14px;
        line-height: 25px;

        .common-select-box {
          ul {
            margin: 0px;

            li {
              margin: 0px;
            }
          }
        }

        ul {
          margin: 10px 20px;
          color: var(--base-dark17-color);
          li {
            display: flex;
            justify-content: space-between;
            margin: 10px 0px;
            text-align: left;

            .left {
              display: flex;
              line-height: 30px;

              .flex-item-box {
                display: flex;

                .common-input-box {
                  margin-left: 10px;
                }
              }

              .name {
                width: 80px;
                .user-center {
                  min-height: 100%;
                  background: var(--aside-bg-color);
                }
                .user-center .el-button--default {
                  height: unset;
                }
                .user-center .content-box {
                  width: 60%;
                  height: 100%;
                  min-width: 800px;
                  min-height: 832px;
                  margin: 0px auto;
                  text-align: left;
                }
                .user-center .content-box .title {
                  padding: 10px 20px;
                  line-height: 25px;
                  color: var(--default-color);
                  font-size: 16px;
                  border-bottom: 1px solid var(--base-bg-dark-color29);
                }
                .user-center .content-box .avatar-bg {
                  padding: 10px 0px;
                  background: url('@/assets/img/usercenter_bg.png') no-repeat
                    center / cover;
                }
                .user-center .content-box .info-box {
                  padding: 20px;
                  border-bottom: 1px solid var(--base-bg-dark-color29);
                }
                .user-center .content-box .info-box .avatar-box {
                  text-align: center;
                  color: var(--default-color);
                }
                .user-center .content-box .info-box .avatar-box .avatar {
                  width: 50px;
                  height: 50px;
                  margin: 0px auto;
                  border-radius: 50%;
                  line-height: 50px;
                  font-size: 30px;
                  text-align: center;
                  background: var(--base-primary-color);
                }
                .user-center .content-box .info-box .avatar-box .name {
                  margin: 10px 0px;
                }
                .user-center .content-box .info-box .info {
                  color: var(--default-color);
                  font-size: 14px;
                  line-height: 25px;
                }
                .user-center
                  .content-box
                  .info-box
                  .info
                  .common-select-box
                  ul {
                  margin: 0px;
                }
                .user-center .content-box .info-box .info ul {
                  margin: 20px;
                  color: var(--base-dark17-color);
                }
                .user-center .content-box .info-box .info ul li {
                  display: flex;
                  justify-content: space-between;
                  margin: 10px 0px;
                  text-align: left;
                }
                .user-center .content-box .info-box .info ul li .left {
                  display: flex;
                  line-height: 30px;
                }
                .user-center .content-box .info-box .info ul li .left .name {
                  width: 80px;
                  margin-right: 20px;
                }
                .user-center .content-box .info-box .info ul li .left .value {
                  width: 240px;
                }
                .user-center
                  .content-box
                  .info-box
                  .info
                  ul
                  li
                  .left
                  .value
                  .special-character {
                  display: inline-block;
                  height: 26px;
                  vertical-align: middle;
                }
                .user-center
                  .content-box
                  .info-box
                  .info
                  ul
                  li
                  .left
                  .el-input__inner {
                  height: 30px;
                  background: var(--base-bg-dark-color22);
                  color: var(--breadcrumb-color);
                  border-color: var(--base-border-light-color10);
                }
                .user-center
                  .content-box
                  .info-box
                  .info
                  ul
                  li
                  .right
                  .el-button {
                  background: var(--base-bg-dark-color22);
                  border-color: var(--base-dark17-color);
                  color: var(--base-dark17-color);
                }

                .user-center .steps {
                  display: inline-flex;
                  width: 100%;
                  justify-content: center;
                  border-bottom: 1px solid var(--dialog-split-line-color);
                }
                .user-center .steps .active {
                  color: var(--base-light-color19);
                }
                .user-center .steps .active .step-line {
                  border-color: var(--base-light-color19);
                }
                .user-center .steps .steps-item {
                  display: flex;
                }
                .user-center .steps .step-line {
                  width: 80px;
                  height: 2px;
                  margin: 10px 20px;
                  border: 1px dashed var(--default-color);
                }
                .user-center .form {
                  padding: 25px 30px 15px;
                }
                .user-center .form .validate {
                  display: flex;
                  justify-content: space-between;
                }
                .user-center .form .validate .action-btn {
                  background: var(--base-bg-dark-color23);
                  border-color: var(--base-bg-dark-color23);
                  color: var(--base-border-light-color10);
                }
                .user-center .form .validate .action-btn-active {
                  color: var(--base-dark14-color);
                }
                .user-center .form label {
                  text-align: left;
                  color: var(--default-color);
                }
                .user-center .form .success-img {
                  padding-top: 20px;
                  padding-bottom: 40px;
                  color: #02cc11;

                  .icon {
                    margin: auto;
                  }
                }
                .user-center .form .success-btn {
                  width: 300px;
                  color: var(--default-color);
                  background: var(--base-border-light-color10);
                  border-color: var(--base-border-light-color10);
                }
                margin-right: 20px;
              }

              .value {
                width: 240px;

                .special-character {
                  display: inline-block;
                  height: 26px;
                  vertical-align: middle;
                }
              }

              .el-input__inner {
                background: var(--base-bg-dark-color22);
                color: var(--breadcrumb-color);
                border-color: var(--base-border-light-color10);
              }
            }
          }
        }
      }
    }
  }

  .steps {
    display: inline-flex;
    width: calc(100% + 32px);
    justify-content: center;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--dialog-split-line-color);
    margin-bottom: 16px;
    margin-left: -16px;

    .steps-item {
      display: flex;
      color: var(--usercenter-binding-text-color);
    }
    .active {
      color: var(--base-primary-bgColor);

      .step-line {
        border-color: var(--base-primary-bgColor);
      }
    }

    .step-line {
      width: 80px;
      height: 2px;
      margin: 10px 10px;
      border: 1px dashed var(--default-color);
    }
  }

  .form {
    .validate {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    label {
      text-align: left;
      color: var(--default-color);
    }

    .success-img {
      padding-top: 20px;
      padding-bottom: 40px;
      color: #02cc11;

      .icon {
        margin: auto;
      }
    }

    .success-btn {
      width: 300px;
      color: var(--aside-bg-color);
      background: var(--base-primary-bgColor);

      :deep(span) {
        justify-content: center;
      }
    }
  }

  .change-password-form {
    :deep(.el-form-item) {
      .el-form-item__error {
        padding-top: 3px;
      }
    }
  }
}
</style>
